<template>
    <Transition name="fade">
        <div v-if="isActive" class="loading-overlay">
            <div class="loading-spinner"></div>
            <p class="loading-message">{{ current?.message || 'loading...' }}</p>
        </div>
    </Transition>
</template>

<script setup>
import {watch} from 'vue' 
import { useLoading } from "@/composables/useLoading";

const { isActive, current } = useLoading();

watch(()=>isActive.value,(newVal)=>{
    // console.log(isActive)
})
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 2px solid #fff;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.loading-message {
    color: white;
    margin-top: 20px;
    font-size: 20px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
